module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alerts.length),
      expression: "alerts.length"
    }],
    staticClass: "app-alerts",
    attrs: {
      "name": "slide-down",
      "tag": "div"
    }
  }, _vm._l((_vm.alerts), function(alert) {
    return _c('div', {
      key: alert.id,
      staticClass: "notification",
      class: 'is-' + alert.type
    }, [_c('button', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          _vm.close(alert.id)
        }
      }
    }), _vm._v("\n    " + _vm._s(_vm.$t(alert.trans.text, alert.trans.data)) + "\n  ")])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20c7fd36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alerts.vue
// module id = 350
// module chunks = 9